module.exports = __webpack_public_path__ + "img/preview-bg.20d8eed1.png";